export const CKP_COLOR_GREEN = '#35C766';
export const ENTRY_WIDTH_UNIT = 300;

export const stateToColor = state => {
    const actualState = (state || 'DEFAULT').toUpperCase().replace(/_/g, '');
    return CLEARANCE_COLORS[actualState] || CLEARANCE_COLORS['DEFAULT'];
};
const CLEARANCE_COLORS = {
    YES: 'green',
    NO: 'red',
    DEFAULT: 'orange',
    TOBECONFIRMED: 'grey'
};



// WEBPACK FOOTER //
// ./src/constants/styling/styles.js